import { createFileRoute } from "@tanstack/react-router";
import { buildPageHead, SITE_URL } from "@/lib/seo";
import Glossary from "@/pages/Glossary";

export const Route = createFileRoute("/glossary")({
  // The dataset is imported lazily so it stays out of the entry bundle; the
  // loader returns only what the head needs. JSON-LD lists term names and
  // anchor URLs, not definitions, to keep the SSR payload small.
  loader: async () => {
    const { GLOSSARY_GROUPS, GLOSSARY_TERM_COUNT } = await import("@/data/glossary");
    return {
      termCount: GLOSSARY_TERM_COUNT,
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "DefinedTermSet",
        "@id": `${SITE_URL}/glossary`,
        name: "Web Analytics Glossary",
        description:
          "Plain-English definitions of web analytics, product metrics, and session replay terms.",
        hasDefinedTerm: GLOSSARY_GROUPS.flatMap((group) =>
          group.terms.map((term) => ({
            "@type": "DefinedTerm",
            name: term.term,
            url: `${SITE_URL}/glossary#${term.id}`,
          })),
        ),
      },
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: "Web Analytics Glossary: Every Term, Defined Simply | Bigdelta",
      description: `${loaderData.termCount} web analytics terms defined in plain English — sessions, bounce rate, funnels, heatmaps, session replay, UTM parameters and more.`,
      path: "/glossary",
      jsonLd: loaderData.jsonLd,
    });
  },
  component: Glossary,
});
